import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import { ProjectsType } from "../../types";
type ProjectState = {
  selectedProject: {
    id: number | null;
    item: ProjectsType.ProjectPartial | null;
  };
  selectedProjectSheet: {
    id: number | null;
    item: Partial<ProjectsType.ProjectSheet> | null;
  };
};

const initial: ProjectState = {
  selectedProject: { id: null, item: null },
  selectedProjectSheet: { id: null, item: null },
};

export const projectSlice = createSlice({
  name: "project",
  initialState: initial as ProjectState,
  reducers: {
    setSelectedProject(
      state: ProjectState,
      action: PayloadAction<ProjectState["selectedProject"]>
    ) {
      state.selectedProject = action.payload;
    },
    clearSelectedProject(state: ProjectState) {
      state.selectedProject = { id: null, item: null };
    },
    setSelectedProjectSheet(
      state,
      action: PayloadAction<ProjectState["selectedProjectSheet"]>
    ) {
      state.selectedProjectSheet = action.payload;
    },

    clearSelectedProjectSheet(state) {
      state.selectedProjectSheet = { id: null, item: null };
    },
  },
});

export const {
  setSelectedProject,
  clearSelectedProject,
  setSelectedProjectSheet,
  clearSelectedProjectSheet,
} = projectSlice.actions;
export const projectReducer = projectSlice.reducer;
